import { render, staticRenderFns } from "./Prevent.vue?vue&type=template&id=22faaa7a&scoped=true&"
var script = {}
import style0 from "./Prevent.vue?vue&type=style&index=0&id=22faaa7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22faaa7a",
  null
  
)

export default component.exports